import { Image, Skeleton } from "antd-mobile";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { CustomDialog } from "../../../../components";
import { usePostFileManager } from "../../hooks/personal.hook";
import Download from "../../icons/Download";
import styles from "./style.module.scss";

function AccountInfo({ userData, isLoading = true }) {
  const [userIconId, setUserIconId] = useState();
  const { t } = useTranslation();
  const { mutate: postFileManager } = usePostFileManager({
    onSuccess: () => {
      CustomDialog({
        type: "show",
        dialogProps: {
          header: t("apply.modalHint"),
          destroyOnClose: true,
          closeOnAction: true,
          content: t("avatarDropdown.downloadHint"),
          actions: [
            {
              key: "close",
              text: t("normal.close"),
            },
          ],
        },
      });
    },
  });
  const findAvatar = (userId) => {
    const iconId = parseInt(userId) % 20;
    // console.log("iconId", iconId);
    setUserIconId(iconId + 1);
  };
  useEffect(() => {
    if (userData?.account_id) {
      findAvatar(userData.account_id);
    }
  }, [userData]);
  return (
    <div className={styles.accountInfo}>
      {isLoading ? (
        <Skeleton
          animated
          style={{
            "--border-radius": "50%",
            "--height": "64px",
            "--width": "64px",
          }}
        />
      ) : (
        <Image
          src={`/images/avatar/avatar${userIconId}.png`}
          width={64}
          height={64}
          className={styles.avatar}
        />
      )}

      <div className={styles.accountBox}>
        <div className={styles.firstLine}>{userData?.account}</div>
        <div className={styles.secondLine}>
          <div
            className={styles.memberCount}
            dangerouslySetInnerHTML={{
              __html: t("mobile.personal.member.count", {
                num: userData?.child_count,
              }),
            }}
          />
          <div
            className={styles.export}
            onClick={async () => {
              const fields = {
                params: JSON.stringify({ account: userData?.account }),
                filename: `export${dayjs().format("YYYYMMDDHHmmss")}`,
              };
              console.log("fdfageg", fields);
              await postFileManager(fields);
            }}
          >
            <span style={{ marginRight: "2px" }}>{t("mobile.personal.member.export")}</span>
            <Download />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountInfo;
